export default {
  methods: {
    /**
     * convert meters to kilometers
     * @param {Number} value
     * @returns {String}
     */
    getKilometers(value) {
      if (!value) {
        return "0 km";
      }

      if (value < 1000 && value > 0) {
        return `${value} m`;
      }

      if (value > -1000 && value < 0) {
        return `do ${Math.abs(value)} m`;
      }

      const kilometers = Math.abs(value) / 1000;

      if (value < -1) {
        return `do ${kilometers.toFixed(2).replace(".", ",")} km`;
      }

      return `${kilometers.toFixed(2).replace(".", ",")} km`;
    },
  },
};
